import { Component, type ErrorInfo, type ReactNode } from 'react'

import { captureException } from './captureException'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class AnalyticsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    captureException(error, { componentStack: info.componentStack ?? undefined })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ color: 'var(--text)', padding: '2rem', textAlign: 'center' }}>
          <p>Something went wrong. Please refresh the page.</p>
        </div>
      )
    }
    return this.props.children
  }
}
